export default "__VITE_ASSET__CqvIZvej__";